

































































































































import Vue, { PropType } from 'vue';
import ArrowUp from 'vue-material-design-icons/ChevronUp.vue';
import ArrowDown from 'vue-material-design-icons/ChevronDown.vue';
import CorrectionModel from '@/dex-shared/models/CorrectionModel';

export default Vue.extend({
  components: {
    ArrowUp,
    ArrowDown,
  },
  props: {
    correction: {
      type: Object as PropType<CorrectionModel>,
      required: true,
    },
  },
  data() {
    return {
      showCaptions: false,
    };
  },
  methods: {
    toggleCaptions: function() {
      this.showCaptions = !this.showCaptions;
    },
    buildStyle: function(correctionScore: any, index: number) {
      let style = 'height: 10px; width: 100%;';
      const perfectEssay = this.correction.score == this.correction.maxScore;
      const lastCorrectionScore =
        index + 1 == this.correction.correctionScores().length;
      if (index == 0) {
        style += 'border-radius: 8px 0px 0px 8px;';
      } else if (perfectEssay && lastCorrectionScore) {
        style += 'border-radius: 0px 8px 8px 0px;';
      }
      style += `background: ${correctionScore.knowledge().color()};`;
      return style;
    },
  },
});
